/**************************************************
 * Created by nanyuantingfeng on 2018/6/19 11:35.
 **************************************************/
import sa from 'sa-sdk-javascript'

global.sa = sa

let staffId
let corpId
let appVersion

export function init(staff) {
  let server_url = `https://sensor.ekuaibao.com/sa?project=default`
  if (process.env.NODE_ENV === 'production') {
    server_url = `https://sensor.ekuaibao.com/sa?project=production`
  }

  sa.init({
    server_url,
    is_track_single_page: false,
    heatmap: { clickmap: 'default', scroll_notice_map: 'default' },
    show_log: process.env.NODE_ENV !== 'production'
  })

  //新增属性,区分平台
  sa.registerPage({
    source: location.host
  })
  // 另外，如果想加额外的属性，可以如下方式（添加 platform 属性为 h5）
  sa.quick('autoTrack', {
    platform: 'web'
  })
  staffId = staff.id

  corpId = staff.corporationId

  sa.login(staffId)
  setTimeout(_ => {
    sa.setProfile({
      name: staff.name,
      phone: staff.cellphone,
      company: staff.corporation.name
    })
  }, 3500)
}

export function initAppConfig(config) {
  appVersion = config?.appVersion
}

const TRACK = (global.TRACK = function(key, options) {
  return (
    staffId &&
    sa.track(key, {
      staffId,
      corpId,
      platForm: global.PLATFORM_FEATURE.name,
      dataSource: 'EKB',
      appVersion,
      ...options
    })
  )
})

TRACK.init = init
TRACK.initAppConfig = initAppConfig

export default TRACK
